//* Import necessary modules
import { useState } from "react";

//* Import Background Image
import BgVestibular from "../../../assets/images/bg_vestibular.jpeg";

//* Import Logo
import Logo from "../../../assets/images/logo-ontest.png";

//* Import moment
import moment from "moment";

//? Import React Transition Group
import { CSSTransition, TransitionGroup } from "react-transition-group";

//* Import React Router
import { useNavigate } from "react-router-dom";

//? Import CSS
import "./ForgotPassword.css";


//* Import necessary components
import { EnterEmailForm } from "../forgot-password/EnterEmailForm";
import { VerifyForm } from "../forgot-password/VerifyForm";
import { ResetPasswordForm } from "../forgot-password/ResetPasswordForm";


export function ForgotPassword() {
  const [currentStep, setCurrentStep] = useState<string>("enterEmail");
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const navigate = useNavigate();

  if (currentStep === "login") {
    navigate("/login");
    return null;
  }

  return (
    <div style={{ height: "100vh" }}>
      <div className="row" style={{ backgroundColor: "white", margin: 0 }}>
        <div
          className="col-md-6 col-12 col-sm-12 col-lg-4 col-xl-4"
          style={{ margin: 0, padding: 0 }}
        >
          <div className="card" style={{ height: "100vh", margin: 0 }}>
            <div
              className="card-body"
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
            >
              <br />
              <div className="text-center">
                <a className="logo">
                  <img
                    style={{ maxHeight: 70,objectFit:'contain' }}
                    src={Logo}
                    height="60"
                    alt="logo"
                  />
                </a>
              </div>
              <br />
              <div
                style={{
                  padding: "1rem",
                  paddingBottom: 0,
                  marginTop: 10,
                  position: "relative",
                }}
              >
                <TransitionGroup>
                  <CSSTransition
                    key={currentStep}
                    timeout={300}
                    classNames="fade"
                  >
                    <div>
                      {currentStep === "enterEmail" && (
                        <EnterEmailForm
                          setCurrentStep={setCurrentStep}
                          email={email}
                          setEmail={setEmail}
                          message={message}
                          setMessage={setMessage}
                        />
                      )}
                      {currentStep === "verifyCode" && (
                        <VerifyForm
                          setCurrentStep={setCurrentStep}
                          email={email}
                          message={message}
                          setMessage={setMessage}
                        />
                      )}
                      {currentStep === "resetPassword" && (
                        <ResetPasswordForm
                          setCurrentStep={setCurrentStep}
                          email={email}
                          message={message}
                          setMessage={setMessage}
                        />
                      )}
                    </div>
                  </CSSTransition>
                </TransitionGroup>
              </div>
              <div className="text-center" style={{ marginTop: 20 }}>
                <p style={{ fontSize: 14 }}>
                  © {moment().format("YYYY")} Allan
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-6 col-sm-6 col-12 col-lg-8 col-xl-8 d-none d-md-block"
          style={{
            overflow: "hidden",
            backgroundImage: `url(${BgVestibular})`,
            backgroundSize: "cover",
            padding: 0,
            margin: 0,
            height: "100vh",
          }}
        ></div>
      </div>
    </div>
  );
}
